import {
  GET_SELLERS,
  CREATE_SELLERS,
  DELETE_SELLERS,
  UPDATE_SELLERS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  sellers: [],
  error: {},
  success: "",
};

const Services = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SELLERS:
          return {
            ...state,
            sellers: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_SELLERS:
          return {
            ...state,
            success: "Sucessfully created sellers",
            error: {},
          };
        case UPDATE_SELLERS:
          return {
            ...state,
            success: "Sucessfully updated sellers",
            error: {},
          };
        case DELETE_SELLERS:
          return {
            ...state,
            success: "Sucessfully delete sellers",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_SELLERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_SELLERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_SELLERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_SELLERS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_SELLERS: {
      return {
        ...state,
      };
    }
    case CREATE_SELLERS: {
      return {
        ...state,
      };
    }
    case UPDATE_SELLERS: {
      return {
        ...state,
      };
    }
    case DELETE_SELLERS: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Services;
